<template>
  <div class="default">
    <Header/>
    <router-view />
    <Footer/>
  </div>
</template>

<script>
  import Header from '@/components/modules/Header'
  import Footer from '@/components/modules/Footer'

  export default {
    name: "Home",
    components: {
      Header,
      Footer,
    },
  };
</script>
